import * as React from 'react';
import DeveloperOptions from './DeveloperOptions';

class FooterState {
    numClicks: number;
}

export default class Footer extends React.Component<undefined, FooterState> {

    constructor(props: undefined) {
        super(props);

        this.state = {
            numClicks: 0
        };
    }
    render() {

        return <div className="Footer">
            <div className="links">
                <a className="ms-Link" target="_blank" href="https://envoy.protectedtrust.com/contact-support/">Support</a>
                |
                <a className="ms-Link" target="_blank" href="https://envoy.protectedtrust.com/terms/">Terms</a>
            </div>
            <div className="version" onClick={() => this.versionClicked()}>
                1.0.11.0 (dev)
            </div>

            {this.state.numClicks >= 5 ? <DeveloperOptions /> : null}
        </div>;
    }

    private versionClicked() {
        if (this.state.numClicks >= 5) {
            this.setState({
                numClicks: 0
            });
        }
        else {
            this.setState({
                numClicks: this.state.numClicks + 1
            });
        }

    }
}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/components/Footer.tsx